import React from "react";
import { CAMP_DAYS, CAMP_DAY_LABELS } from "../../lib/api";

export const DAYS = CAMP_DAYS;

export function trainingDays(services) {
  const set = new Set();
  ["football", "goalkeeper"].forEach((k) => {
    const s = services[k] || {};
    if (s.type === "daily" || s.type === "double") DAYS.forEach((d) => set.add(d));
    if (s.type === "individual") Object.entries(s.days || {}).forEach(([d, c]) => { if (c > 0) set.add(Number(d)); });
  });
  return set;
}

// Drops meal days that no longer have a training booking.
export function withValidMeals(services) {
  const td = trainingDays(services);
  return { ...services, meals: { days: (services.meals.days || []).filter((d) => td.has(d)) } };
}

export function DayChip({ day, count, max, onClick, disabled, testid }) {
  const active = count > 0;
  const tone = disabled ? "opacity-40 cursor-not-allowed border-slate-200 bg-slate-50"
    : active ? "border-[#008057] bg-[#008057] text-white" : "border-[#E2EBF0] bg-white text-slate-600 hover:border-[#008057]";
  return (
    <button type="button" data-testid={testid} disabled={disabled} onClick={onClick}
      className={`relative rounded-xl border-2 px-3 py-2 text-sm font-semibold transition-colors ${tone}`}>
      {CAMP_DAY_LABELS[day]}
      {max > 1 && active && (
        <span className="ml-1.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#F3C242] text-[#03281B] text-[11px] font-extrabold">{count}</span>
      )}
    </button>
  );
}

export function DayChips({ prefix, max, countFor, onClick, disabledFor }) {
  return (
    <div className="flex flex-wrap gap-2">
      {DAYS.map((d) => (
        <DayChip key={d} day={d} max={max} count={countFor(d)} disabled={disabledFor ? disabledFor(d) : false} onClick={() => onClick(d)} testid={`${prefix}-day-${d}`} />
      ))}
    </div>
  );
}

export function TypeRadio({ name, value, current, label, price, onChange, testid }) {
  return (
    <label data-testid={testid}
      className={`flex items-center justify-between gap-3 rounded-xl border-2 px-4 py-3 cursor-pointer transition-colors ${current === value ? "border-[#008057] bg-[#F2F8F5]" : "border-[#E2EBF0] bg-white hover:border-[#008057]/40"}`}>
      <div className="flex items-center gap-3">
        <input type="radio" name={name} checked={current === value} onChange={() => onChange(value)} className="accent-[#008057]" />
        <span className="text-sm font-semibold text-[#03281B]">{label}</span>
      </div>
      {price != null && <span className="font-display font-bold text-[#008057]">{price}</span>}
    </label>
  );
}
